import { render } from "./OrderHistoryPage.vue?vue&type=template&id=6a3f4595"
import script from "./OrderHistoryPage.vue?vue&type=script&lang=js"
export * from "./OrderHistoryPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__